
import * as React from 'react'

const Navigation = ({ children, onClick, isActive }) => {

  return (
    <div
      onClick={onClick}
      className={`tw-z-10  tw-cursor-pointer tw-text-nowrap tw-p-4 tw-text-sm tw-font-medium hover:tw-no-underline ${
        isActive
          ? 'tw-z-10 tw-border-b-[2px] tw-border-blue-600 tw-font-medium tw-text-blue-600'
          : 'tw-border-b-[2px] tw-border-transparent tw-text-content-base hover:tw-text-blue-600'
      }`}
    >
      {children}
    </div>
  )
}

export default Navigation
